/* Handling of core donation related state */
import {
  GET_COUNTRIES_SUCCESS,
  SET_ISO_COMPLIANT_COUNTRIES
} from '@stores/mutation-types';

import {
  Main as Donation
} from '@services/App/donation';

const state = () => ({
  countries: [],
  isoCountries: []
});

const mutations = {

  /**
   * @param {object} state Stripe module states
   * @param {object} countries Country list
   *
   * @return void
   */
  [GET_COUNTRIES_SUCCESS]: (state, countries) => {
    state.countries = countries;
  },

  /**
   * Set ISO compliant countries
   *
   * @param {object} state Stripe module states
   * @param {object} countries Country list
   *
   * @return {void}
   */
  [SET_ISO_COMPLIANT_COUNTRIES]: (state, countries) => {
    state.isoCountries = countries;
  }

};

const actions = {

  /**
   * Get list of all countries
   *
   * @param {object} context Vuex context keys
   *
   * @return {promise}
   */
  async retrieveCountries({ state, commit }) {
    if (state.countries.length > 0) {
      return;
    }
    const response = await Donation.getCountries();
    if (response.success) {
      commit(GET_COUNTRIES_SUCCESS, response.data);
    }
    return response;
  },

  /**
   * Get list of ISO compliant countries
   *
   * @param {object}
   *
   * @return {object}
   */
  async retrieveIsoCompliantCountries({state, commit}) {
    const response = await Donation.getCountries(true);

    if (response.success) {
      commit(SET_ISO_COMPLIANT_COUNTRIES, response.data);
    }
  }

};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
